module.exports = __webpack_public_path__ + "static/recommendation@2x-249f83d54d60213b00b549342e63d4d1.png";